<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->
            </div>
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <!-- CONTENT -->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;" *ngIf=" dataId.id == '111'">
                <div aling="center">
                    <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <div *ngFor="let datita of info ">
                    <p *ngIf=" dataId.id == datita.position">{{ datita.title | translate}}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.subtitle | translate}}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.content | translate}}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.content2 | translate}}</p>
                </div>

                <div *ngFor="let datitaDef of preguntasSeccion1 ">

                    <p *ngIf=" dataId.id =='111'">{{datitaDef.def | translate}}</p>
                    <div *ngFor="let ques of datitaDef.seccion">

                        <p *ngIf=" ques.id =='41' ">

                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION1_LABEL01' | translate }}
                        </p>
                        <table class="blueTable table" style="width: 8%; margin-bottom: 2%;" *ngIf="ques.id=='44'">
                            <tbody>
                                <tr>
                                    <th scope="col" style="width: 5%;">
                                        {{ 'WIZARD.Guia3.TABLES.LABEL06' | translate }}
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" style="width: 5%;">
                                        {{ 'WIZARD.Guia3.TABLES.LABEL07' | translate }}
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        <p *ngIf=" ques.id =='44' ">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION1_LABEL02' | translate }}
                        </p>
                        <table class="blueTable table" style="width: 8%; margin-bottom: 2%;" *ngIf=" ques.id =='41'">
                            <tbody>
                                <tr>
                                    <th scope="col" style="width: 5%;">{{ 'WIZARD.Guia3.TABLES.LABEL06' | translate }}</th>
                                </tr>
                                <tr>
                                    <th scope="col" style="width: 5%;">{{ 'WIZARD.Guia3.TABLES.LABEL07' | translate }}</th>
                                </tr>
                            </tbody>
                        </table>

                        <p *ngIf="ques.id =='41'">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION1_LABEL03' | translate }}
                        </p>
                        <p *ngIf="ques.id=='44'">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION1_LABEL04' | translate }}
                        </p>
                        <br *ngIf=" ques.id =='65' || ques.id=='69'">
                    </div>

                    <table class="blueTable table" style="width: 100%;">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 5%;"></th>
                                <th scope="col" style="width: 55%;"></th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL01' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL02' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL03' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL04' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL05' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let ques of datitaDef.seccion">
                            <tr>
                                <th scope="row" style="width: 5%;">{{ques.id}}</th>
                                <th scope="row" style="width: 55%;">{{ques.pregunta | translate}}</th>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                            </tr>
                        </tbody>
                    </table><br>
                </div>
            </div>
            <!--END FIRTS SECCION-->


            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;" *ngIf=" dataId.id == '112'">
                <div aling="center">
                    <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <div *ngFor="let datita of info ">
                    <p *ngIf=" dataId.id == datita.position">{{datita.title | translate}}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.subtitle | translate }}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.content | translate }}</p>
                    <p *ngIf=" dataId.id == datita.position">{{datita.content2 | translate }}</p>
                </div>

                <div *ngFor="let datitaDef of preguntasSeccion2 ">
                    <p *ngIf=" dataId.id =='112'">{{datitaDef.def | translate }}</p>
                    <div *ngFor="let ques of datitaDef.seccion">
                        <p *ngIf=" ques.id =='65'">

                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION2_LABEL01' | translate }}
                        </p>
                        <table class="blueTable table" style="width: 8%; margin-bottom: 2%;" *ngIf="ques.id=='69'">
                            <tbody>
                                <tr>
                                    <th scope="col" style="width: 5%;"> {{ 'WIZARD.Guia3.TABLES.LABEL06' | translate }} </th>
                                </tr>
                                <tr>
                                    <th scope="col" style="width: 5%;"> {{ 'WIZARD.Guia3.TABLES.LABEL07' | translate }} </th>
                                </tr>
                            </tbody>
                        </table>
                        <p *ngIf=" ques.id =='69'">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION2_LABEL02' | translate }}
                        </p>

                        <table class="blueTable table" style="width: 8%; margin-bottom: 2%;" *ngIf=" ques.id =='65' ">
                            <tbody>
                                <tr>
                                    <th scope="col" style="width: 5%;"> {{ 'WIZARD.Guia3.TABLES.LABEL06' | translate }}</th>
                                </tr>
                                <tr>
                                    <th scope="col" style="width: 5%;"> {{ 'WIZARD.Guia3.TABLES.LABEL07' | translate }}</th>
                                </tr>
                            </tbody>
                        </table>
                        <p *ngIf=" ques.id =='65' ">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION2_LABEL03' | translate }}
                        </p>
                        <p *ngIf="ques.id=='69'">
                            {{ 'WIZARD.Guia3.PREGUNTAS.SECCION2_LABEL04' | translate }}
                        </p>
                        <br *ngIf=" ques.id =='65' || ques.id=='69'">
                    </div>
                    <table class="blueTable table">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 5%;"></th>
                                <th scope="col" style="width: 55%;"></th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL01' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL02' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL03' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL04' | translate }}</th>
                                <th scope="col" style="width: 8%;"> {{ 'WIZARD.Guia3.TABLES.LABEL05' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let ques of datitaDef.seccion">
                            <tr>
                                <th scope="col" style="width: 5%;">{{ques.id}} </th>
                                <th scope="row" style="width: 55%;">{{ques.pregunta | translate }}</th>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                                <td style="width: 8%;"></td>
                            </tr>
                        </tbody>
                    </table><br>
                </div>
            </div>
            <!--END SECONND SECCION-->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">








            </div>
            <!--<div *ngIf=" dataId.id == datita.position ">-->
        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->